import LayoutFactory from './LayoutFactory';
export default LayoutFactory;
//# sourceMappingURL=index.js.map